export const app_url = "/"

export const fixedIds = {
  // services
  cis: 5,
  payroll: 6,
  bookkeeping: 7,
  managementAccount: 8,

  // client types
  individual: "1",
  partnership: "2",

  // archive user
  archiveUser: 1,
  archivedRoleId: 5,

  // status
  dataReceived: 11,
  HMRCStatus: 18,
}
